import { Dispatch } from '@reduxjs/toolkit';
import {connect} from "react-redux";

import { LoginView } from "../view/view";
import { requestDataFromAPI } from '../../UserTableThingy/thunk/table_tunc';
import { requestUserCreationFromAPI } from '../thunk/request_func';
import { RootState } from '../../../app/store';

function mapStateToProps(state:RootState){
    // state:rootState includes all global variables as state
    const myprops=
    {
        // I can assign local variables for global vars         
        loginuser:state.LoginManager.model.username,
        loginrole:state.LoginManager.model.role,
        token:state.UserInput.view.token,
        // this variable is pure local an not recommended
        localtest: "string", // fill this with value no reference
    }
    // Return the whole construct to the container itself
    return myprops;
    // NEVER Add ACtions or Functions here
}



function bindDispatchToActions(dispatch:Dispatch<any>){
    return {
        // Include/Define every funciton that might be called here
        onSubmit:(data:any, password:string, passwordverification:string)=>{
            console.log(data);
           data.password = password;
           data.passwordverification = passwordverification
           
            dispatch(requestUserCreationFromAPI(data)  as any);
            console.log("Dispatch should be done");
            setTimeout(() => {
                  console.log("Update User Table now");
                  dispatch(requestDataFromAPI() as any);
              }, 2000);
            
        }
    }
}

const CreateUserContainer=connect(mapStateToProps, bindDispatchToActions)(LoginView);
export default CreateUserContainer;